import { SiteId } from "@ubnt/store.core/lib/contexts/MenuContext/mapping";
import { StaticGlobalSiteConfigExplicit } from "@ubnt/store.core/lib/contexts/MenuContext/types";
import { CountryCode, StoreId, Language } from "@ubnt/store.core/lib/types";

// #############################################################################
// Utils to prepare
// #############################################################################
const convertLanguageObjectToArray = (parentObject: Record<string, string>) => {
  if (!!parentObject["languages"]) {
    return {
      ...parentObject,
      languages: Object.values(parentObject.languages),
    };
  }
  return parentObject;
};

const processInjectedGlobalSiteConfig = (
  globalSiteConfig,
): StaticGlobalSiteConfigExplicit => {
  return Object.entries(globalSiteConfig).reduce((acc, [key, value]) => {
    acc[key] = convertLanguageObjectToArray(value);

    if (!!value?.defaultRegion) {
      acc[key] = {
        ...acc[key],
        defaultRegion: convertLanguageObjectToArray(value.defaultRegion),
      };
    }

    if (!!value?.regions) {
      acc[key] = {
        ...acc[key],
        regions: Object.entries(value.regions).reduce(
          (acc, [regionKey, regionValue]) => {
            acc[regionKey] = convertLanguageObjectToArray(regionValue);
            return acc;
          },
          {},
        ),
      };
    }

    return acc;
  }, {}) as unknown as StaticGlobalSiteConfigExplicit;
};

// #############################################################################
// Constants
// #############################################################################
export const GLOBAL_SITE_CONFIG = processInjectedGlobalSiteConfig(
  JSON.parse(__CONFIG__.GLOBAL_SITE_CONFIG),
);

export const UI_COM_SITE_CONFIG = GLOBAL_SITE_CONFIG[SiteId.Ui];

export const DEFAULT_STORE_ID = StoreId.Us;
export const DEFAULT_LANGUAGE =
  UI_COM_SITE_CONFIG.defaultRegion.defaultLanguage ?? Language.En;
export const DEFAULT_COUNTRY_CODE = CountryCode.Us;
